import React, { useContext } from "react";
import AuthContext from "../global/auth-context";
import { Link } from "react-router";

const Footer = () => {
  let { adminDetails, isLoading } = useContext(AuthContext);
  return (
    <div className="flex bg-myDarkGreen w-screen px-5  flex-col self-end">
      <div className="flex justify-between w-full pr-5 py-10 flex-wrap">
        <div className="flex flex-col px-5 w-fit flex-1 ">
          <span className="text-yellow-500 font-medium text-lg py-3">
            Socials
          </span>
          <div className="flex-col flex gap-1">
            <Link
              target="_blank"
              onClick={() => {
                window.open(adminDetails.socials.facebook);
              }}
              className="text-white font-normal text-lg hover:text-yellow-500"
            >
              Facebook
            </Link>
            <Link
              target="_blank"
              onClick={() => {
                window.open(adminDetails.socials.whatsappChannel);
              }}
              className="text-white font-normal text-lg  hover:text-yellow-500"
            >
              Whatsapp
            </Link>
            <Link
              target="_blank"
              onClick={() => {
                window.open(adminDetails.socials.telegram);
              }}
              className="text-white font-normal text-lg  hover:text-yellow-500 "
            >
              Telegram
            </Link>
            <Link
              target="_blank"
              onClick={() => {
                window.open(adminDetails.socials.twitter);
              }}
              className="text-white font-normal text-lg   hover:text-yellow-500"
            >
              Twitter
            </Link>
          </div>
        </div>
        <div className="flex flex-col px-5 w-fit flex-1">
          <span className="text-yellow-500 font-medium text-lg py-3">
            Informations
          </span>
          <div className="flex-col flex gap-1">
            <a
              href={"/privacy"}
              className="text-white font-normal text-lg hover:text-yellow-500"
            >
              Terms & Conditions
            </a>
            <a
              href={"/disclaimer"}
              className="text-white font-normal text-lg  hover:text-yellow-500"
            >
              Disclaimer
            </a>
            <a
              href={"/about"}
              className="text-white font-normal text-lg  hover:text-yellow-500 "
            >
              About Us
            </a>
            <a
              href={"/refund"}
              className="text-white font-normal text-lg   hover:text-yellow-500"
            >
              Refund Policy
            </a>

            <a
              href={"/privacy"}
              className="text-white font-normal text-lg   hover:text-yellow-500"
            >
              Privacy Policy
            </a>
          </div>
        </div>
        <div className="flex flex-col px-5 w-fit flex-1">
          <span className="text-yellow-500 font-medium text-lg py-3">
            Contact Us
          </span>
          <div className="flex-col flex gap-1">
            <text className="text-white font-normal text-lg">Email Us</text>
            <a
              href="mailto:GreenluckTips@gmail.com"
              className="text-white font-normal text-lg  hover:text-yellow-500"
            >
              GreenluckTips@gmail.com
            </a>
          </div>
        </div>
      </div>
      <div className="w-full flex justify-center border-t-2">
        <text className="text-white  font-normal text-lg pt-5 pb-10 text-center">
          © Copyright © 2023 - Green Luck Tips - All Right Reserved
        </text>
      </div>
    </div>
  );
};

export default Footer;
